import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * This component is needed to scroll the body content back to the top
 * when changing between routes
 */
export default function ScrollToTop({children}) {
	const { pathname } = useLocation()

	useEffect(() => {
		window.document.getElementById('BodyContent').scrollTo(0, 0)
	}, [pathname])

	return null
}